import React from 'react'
import { useState, useRef } from 'react';
import { Box, Typography, IconButton, Skeleton } from '@mui/material'
import ShareIcon from "@mui/icons-material/Share";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Dialog, DialogContent } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Slider from "react-slick";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import YouTubeIcon from "@mui/icons-material/YouTube";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const Syndicate_properties_card = ({ name, property_type, location, project_name, total_area, starting_price, uld_no, prop_status, plotCount, price_per, images = [], loading, youtubeLink, whatsappNumber }) => {


  const isVideo = (url) => {
    if (typeof url !== 'string') return false;
    return url.match(/\.(mp4|webm|mkv|mov|avi)$/i);
  };

  const [openPreview, setOpenPreview] = useState(false);
  const previewSliderRef = useRef();
  const sliderRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const videoRefs = useRef({});
  const [playingVideo, setPlayingVideo] = useState(null);
  const [loadedMedia, setLoadedMedia] = useState({});
  const [hoveredVideo, setHoveredVideo] = useState(null);

  const handleMediaLoad = (src) => {
    setLoadedMedia((prev) => ({ ...prev, [src]: true }));
  };

  const togglePlay = (e, src) => {
    e.stopPropagation();
    const video = videoRefs.current[src];
    if (video) {
      if (video.paused) {
        if (playingVideo && playingVideo !== src && videoRefs.current[playingVideo]) {
          videoRefs.current[playingVideo].pause();
        }
        video.play();
        setPlayingVideo(src);
      } else {
        video.pause();
        setPlayingVideo(null);
      }
    }
  };

  const handleImagePreview = (idx) => {
    setActiveIndex(idx);
    setOpenPreview(true);
    setTimeout(() => {
      previewSliderRef.current?.slickGoTo(idx);
    }, 100);
  };

  const cardSliderSettings = {
    dots: false,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    infinite: false,
    beforeChange: (oldIndex, newIndex) => {
      Object.values(videoRefs.current).forEach(vid => {
        if (vid && !vid.paused) vid.pause();
      });
      setPlayingVideo(null);
    }
  };


  const safeImage = Array.isArray(images) ? images : []
  const showArrows = safeImage.length > 1;

  const handleShare = () => {
    const shareUrl = window.location.href;

    if (navigator.share) {
      navigator.share({
        title: "Property",
        text: "Check out this property",
        url: shareUrl,
      });
    } else {
      navigator.clipboard.writeText(shareUrl);
      alert("Link copied to clipboard");
    }
  };



  const formatPrice = (num) => {
    if (num === null || num === undefined || isNaN(Number(num))) return "-";
    num = Number(num);

    let formatted = "";

    if (num >= 10000000) formatted = (num / 10000000).toFixed(2) + " Cr";
    else if (num >= 100000) formatted = (num / 100000).toFixed(2) + " Lakhs";
    else if (num >= 1000) formatted = (num / 1000).toFixed(2) + " K";
    else formatted = num.toString();

    return `₹ ${formatted}`;
  };

  return (
    <Box
      sx={{
        py: 4,
        px: 3,
        m: "auto",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        borderRadius: 6,
        boxShadow: 2,
        color: "black",
        width: { xs: "100%", sm: 320, md: 450 },
      }}
    >


      <Box>
        {/* IMAGE AREA */}
        <Box
          sx={{
            width: "100%",
            height: 280,
            borderRadius: 4,
            overflow: "hidden",
            position: "relative",
          }}
        >
          {loading ? (
            <Skeleton
              variant="rectangular"
              animation="wave"
              width="100%"
              height="100%"
              sx={{ borderRadius: 2 }}
            />
          ) : safeImage.length > 1 ? (
            <Box
              sx={{
                width: "100%",
                height: 280,
                position: "relative",
                "& .slick-slider, & .slick-list, & .slick-track, & .slick-slide > div": {
                  height: "100% !important",
                },
              }}
            >
              <Slider {...cardSliderSettings} ref={sliderRef}>
                {safeImage.map((img, i) => (
                  <Box key={i}>
                    {isVideo(img) ? (
                      <Box sx={{ position: "relative", width: "100%", height: 280 }}>
                        {!loadedMedia[img] && (
                          <Skeleton
                            variant="rectangular"
                            width="100%"
                            height="100%"
                            sx={{ position: "absolute", top: 0, left: 0 }}
                          />
                        )}
                        <Box
                          onMouseEnter={() => setHoveredVideo(img)}
                          onMouseLeave={() => setHoveredVideo(null)}
                          sx={{ position: "relative", width: "100%", height: "100%" }}
                        >                           <video
                            ref={(el) => (videoRefs.current[img] = el)}
                            src={img}
                            playsInline
                            disablePictureInPicture
                            disableRemotePlayback
                            controlsList="nopictureinpicture nodownload"
                            preload="metadata"
                            onLoadedData={() => handleMediaLoad(img)}
                            onMouseEnter={() => setHoveredVideo(img)}
                            onMouseLeave={() => setHoveredVideo(null)}
                            onClick={(e) => {
                              if (playingVideo !== img) {
                                togglePlay(e, img);
                              } else {
                                handleImagePreview(i);
                              }
                            }}
                            style={{
                              width: "100%",
                              height: 280,
                              objectFit: "cover",
                              cursor: "pointer",
                              transition: "transform 0.3s ease",
                              display: loadedMedia[img] ? "block" : "none",
                            }}
                          />
                          {/* Standard Rectangular Play/Pause Buttons */}
                          {loadedMedia[img] && (
                            <Box
                              onClick={(e) => togglePlay(e, img)}
                              onMouseEnter={() => setHoveredVideo(img)}
                              onMouseLeave={() => setHoveredVideo(null)}
                              sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                bgcolor: "rgba(0,0,0,0.5)",
                                color: "white",
                                width: 50,
                                height: 40,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                borderRadius: "4px",
                                opacity: playingVideo === img ? (hoveredVideo === img ? 1 : 0) : 1,
                                transition: "opacity 0.2s ease",
                                zIndex: 2,
                              }}
                            >
                              {playingVideo === img ? (
                                <PauseIcon sx={{ fontSize: 30 }} />
                              ) : (
                                <PlayArrowIcon sx={{ fontSize: 30 }} />
                              )}
                            </Box>
                          )}

                        </Box>
                      </Box>
                    ) : (
                      <Box sx={{ position: "relative", width: "100%", height: 280 }}>
                        {!loadedMedia[img] && (
                          <Skeleton
                            variant="rectangular"
                            width="100%"
                            height="100%"
                            sx={{ position: "absolute", top: 0, left: 0 }}
                          />
                        )}
                        <img
                          src={img || "/assets/images/placeholder_img.png"}
                          onLoad={() => handleMediaLoad(img)}
                          onClick={() => handleImagePreview(i)}
                          alt="preview"
                          style={{
                            width: "100%",
                            height: 280,
                            objectFit: "cover",
                            cursor: "zoom-in",
                            transition: "transform 0.3s ease",
                            display: loadedMedia[img] ? "block" : "none",
                          }}
                        />
                      </Box>
                    )}
                  </Box>
                ))}
              </Slider>
              {showArrows && (
                <>
                  <IconButton
                    onClick={(e) => { e.stopPropagation(); sliderRef.current?.slickPrev(); }}
                    sx={{
                      position: "absolute", left: 8, top: "50%", transform: "translateY(-50%)",
                      zIndex: 2, bgcolor: "rgba(255,255,255,0.7)", p: 0.5,
                      "&:hover": { bgcolor: "white" }
                    }}
                  >
                    <ArrowBackIosNewIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                  <IconButton
                    onClick={(e) => { e.stopPropagation(); sliderRef.current?.slickNext(); }}
                    sx={{
                      position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)",
                      zIndex: 2, bgcolor: "rgba(255,255,255,0.7)", p: 0.5,
                      "&:hover": { bgcolor: "white" }
                    }}
                  >
                    <ArrowForwardIosIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                  <Box sx={{ position: "absolute", bottom: 14, right: 12, bgcolor: "rgba(0,0,0,0.55)", color: "#fff", fontSize: 11, fontWeight: 700, borderRadius: "6px", px: 1, py: 0.2, pointerEvents: "none", zIndex: 2 }}>
                    +{safeImage.length - 1} more
                  </Box>
                </>
              )}
            </Box>
          ) : (
            isVideo(safeImage[0]) ? (
              <Box sx={{ position: "relative", width: "100%", height: 280 }}>
                {!loadedMedia[safeImage[0]] && (
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height="100%"
                    sx={{ position: "absolute", top: 0, left: 0 }}
                  />
                )}
                <Box
                  onMouseEnter={() => setHoveredVideo(safeImage[0])}
                  onMouseLeave={() => setHoveredVideo(null)}
                  sx={{ position: "relative", width: "100%", height: "100%" }}
                >
                  <video
                    ref={(el) => (videoRefs.current[safeImage[0]] = el)}
                    src={safeImage[0]}
                    playsInline
                    disablePictureInPicture
                    disableRemotePlayback
                    controlsList="nopictureinpicture nodownload"
                    preload="metadata"
                    onLoadedData={() => handleMediaLoad(safeImage[0])}
                    onMouseEnter={() => setHoveredVideo(safeImage[0])}
                    onMouseLeave={() => setHoveredVideo(null)}
                    onClick={(e) => {
                      if (playingVideo !== safeImage[0]) {
                        togglePlay(e, safeImage[0]);
                      } else {
                        handleImagePreview(0);
                      }
                    }}
                    style={{
                      width: "100%",
                      height: 280,
                      objectFit: "cover",
                      cursor: "pointer",
                      display: loadedMedia[safeImage[0]] ? "block" : "none",
                    }}
                  />
                  {/* Standard Rectangular Play/Pause Buttons */}
                  {loadedMedia[safeImage[0]] && (
                    <Box
                      onClick={(e) => togglePlay(e, safeImage[0])}
                      onMouseEnter={() => setHoveredVideo(safeImage[0])}
                      onMouseLeave={() => setHoveredVideo(null)}
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        bgcolor: "rgba(0,0,0,0.5)",
                        color: "white",
                        width: 50,
                        height: 40,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        borderRadius: "4px",
                        opacity: playingVideo === safeImage[0] ? (hoveredVideo === safeImage[0] ? 1 : 0) : 1,
                        transition: "opacity 0.2s ease",
                        zIndex: 2,
                      }}
                    >
                      {playingVideo === safeImage[0] ? (
                        <PauseIcon sx={{ fontSize: 30 }} />
                      ) : (
                        <PlayArrowIcon sx={{ fontSize: 30 }} />
                      )}
                    </Box>
                  )}
                </Box>
              </Box>
            ) : (
              <Box sx={{ position: "relative", width: "100%", height: 280 }}>
                {!loadedMedia[safeImage[0]] && (
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height="100%"
                    sx={{ position: "absolute", top: 0, left: 0 }}
                  />
                )}
                <img
                  src={safeImage[0] || "/assets/images/placeholder_img.png"}
                  onLoad={() => handleMediaLoad(safeImage[0])}
                  onClick={() => handleImagePreview(0)}
                  alt="preview"
                  style={{
                    width: "100%",
                    height: 280,
                    objectFit: "cover",
                    cursor: "zoom-in",
                    display: loadedMedia[safeImage[0]] ? "block" : "none",
                  }}
                />
              </Box>
            )
          )}


          {/* Share Icon (top-right) */}
          <IconButton
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              background: "white",

            }}
            onClick={handleShare}
          >
            <ShareIcon fontSize="small" />
          </IconButton>

          {/* WhatsApp Icon (next to share) */}
          <IconButton
            sx={{
              position: "absolute",
              top: 10,
              right: 50,
              background: "white",
              "&:hover": { background: "#f5f5f5" },
            }}
            onClick={(e) => {
              e.stopPropagation();
              const shareUrl = window.location.href;
              const shareText = `Check out this property: ${name || "Property"}\n${shareUrl}`;
              window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(shareText)}`, "_blank");
            }}
          >
            <WhatsAppIcon sx={{ color: "#25D366" }} fontSize="small" />
          </IconButton>

          {/* YouTube Icon (straight bottom to share icon) */}
          {youtubeLink && (
            <IconButton
              sx={{
                position: "absolute",
                bottom: 10,
                right: 10,
                background: "white",
                "&:hover": { background: "#f5f5f5" },
              }}
              onClick={() => window.open(youtubeLink, "_blank")}
            >
              <YouTubeIcon sx={{ color: "#FF0000" }} fontSize="small" />
            </IconButton>
          )}
        </Box>

        {/* Pagination Dots (informational) */}
        {safeImage?.length > 1 && (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
            {safeImage.map((_, i) => (
              <Box
                key={i}
                sx={{
                  width: 7,
                  height: 7,
                  borderRadius: "50%",
                  background: i === activeIndex ? "black" : "#ccc",
                  mx: 0.7,
                  transition: "background 0.3s ease",
                }}
              />
            ))}
          </Box>
        )}
      </Box>
      {/* <Box
        component="img"
        src={image || "/assets/images/placeholder_bg.png"}
        alt="Plot"
        sx={{ width: "100%", height: "60%", borderRadius: 2 }}
      /> */}


      <Typography color="primary" sx={{ py: 1 }} variant="h6">
        Details
      </Typography>


      {/* <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "row", sm: "row" },
          gap: 4,
          px: 1,
        }}
      >
        <Box>
          {["Project Name", "Location", "Total Layout Area", "Plot Count", "Price per Sq.ft", "Starting Price", "Status", "ULPIN"].map((item, i) => (
            <Typography key={i} sx={{ mb: 0.5 }}>
              {item}
            </Typography>
          ))}
        </Box>

        <Box>
          {[name, location, total_area, "Project Name", "Project Name", formatPrice(starting_price), prop_status, uld_no].map((item, i) => (
            <Typography key={i} sx={{ mb: 0.5 }}>
              {item}
            </Typography>
          ))}
        </Box>
      </Box> */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          px: 1,
        }}
      >
        {[
          ["Project Name", name],
          ["Property Type", property_type],
          ["Location", location],
          ["Total Layout Area", total_area ? `${total_area} sq.ft` : "-"],
          ["Plot Count", plotCount],
          ["Price per Sq.ft", formatPrice(price_per)],
          ["Starting Price", formatPrice(starting_price)],
          // ["Status", prop_status],
          ["ULPIN", uld_no],
        ].map(([label, value], i) => (
          <Box key={i} sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
                flex: { xs: "0 0 40%", sm: "0 0 40%", md: "0 0 45%" },
              }}
            >
              {label}
            </Typography>

            <Typography
              sx={{
                maxWidth: "60%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                textAlign: "right",
              }}
              title={value || "-"}
            >
              {value || "-"}
            </Typography>
          </Box>
        ))}
      </Box>


      <Dialog
        open={openPreview}
        onClose={() => setOpenPreview(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            overflow: "hidden",
            bgcolor: "rgba(0,0,0,0.5)",
          },
        }}
      >
        {/* CLOSE BUTTON (TOP RIGHT) */}
        <IconButton
          onClick={() => setOpenPreview(false)}
          sx={{
            position: "absolute",
            top: { xs: 10, sm: 16 },
            right: { xs: 10, sm: 20 },
            zIndex: 10,
            color: "#fff",
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent sx={{ p: 0 }}>
          <Box
            sx={{
              position: "relative",
              height: { xs: 320, sm: 500, md: 600 },
              bgcolor: "transparent",
              overflow: "hidden"
            }}
          >
            {/* LEFT ARROW */}
            {safeImage.length > 1 && (
              <IconButton
                onClick={() => previewSliderRef.current?.slickPrev()}
                sx={{
                  position: "absolute",
                  left: 12,
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 3,
                  color: "#fff",
                  bgcolor: "rgba(0,0,0,0.5)",

                  "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
                }}
              >
                <ArrowBackIosNewIcon />
              </IconButton>
            )}
            {/* SLIDER */}
            <Slider
              ref={previewSliderRef}
              initialSlide={activeIndex}
              beforeChange={(old, next) => {
                const src = safeImage[old];
                const vid = videoRefs.current[src];
                if (vid) vid.pause();
                setPlayingVideo(null);
                setActiveIndex(next);
              }}
              dots
              infinite={false}
              speed={400}
              slidesToShow={1}
              slidesToScroll={1}
              arrows={false}
            >
              {safeImage?.map((img, i) => (
                <Box key={i}>
                  <Box
                    sx={{
                      height: { xs: 320, sm: 500, md: 600 },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: "rgba(0,0,0,0.5)",
                      p: 1,
                      position: "relative",
                    }}
                  >
                    {!loadedMedia[img] && (
                      <Skeleton
                        variant="rectangular"
                        width="100%"
                        height="100%"
                        sx={{ position: "absolute", top: 0, left: 0, bgcolor: "rgba(255,255,255,0.1)" }}
                      />
                    )}
                    {isVideo(img) ? (
                      <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
                        <video
                          ref={(el) => (videoRefs.current[img] = el)}
                          src={img}
                          playsInline
                          disablePictureInPicture
                          disableRemotePlayback
                          controlsList="nodownload nopictureinpicture"
                          onLoadedData={() => handleMediaLoad(img)}
                          onClick={(e) => togglePlay(e, img)}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            display: loadedMedia[img] ? "block" : "none",
                            cursor: "pointer",
                          }}
                        />
                        {/* Standard Rectangular Play/Pause Buttons */}
                        {loadedMedia[img] && (
                          <Box
                            onClick={(e) => togglePlay(e, img)}
                            sx={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              bgcolor: "rgba(0,0,0,0.5)",
                              color: "white",
                              width: 60,
                              height: 50,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                              borderRadius: "4px",
                              zIndex: 2,
                            }}
                          >
                            {playingVideo === img ? (
                              <PauseIcon sx={{ fontSize: 40 }} />
                            ) : (
                              <PlayArrowIcon sx={{ fontSize: 40 }} />
                            )}
                          </Box>
                        )}
                      </Box>
                    ) : (
                      <img
                        src={img}
                        alt=""
                        onLoad={() => handleMediaLoad(img)}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          display: loadedMedia[img] ? "block" : "none",
                        }}
                      />
                    )}
                  </Box>
                </Box>
              ))}
            </Slider>

            {/* RIGHT ARROW */}
            {safeImage.length > 1 && (
              <IconButton
                onClick={() => previewSliderRef.current?.slickNext()}
                sx={{
                  position: "absolute",
                  right: 12,
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 3,
                  color: "#fff",
                  bgcolor: "rgba(0,0,0,0.5)",
                  "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
                }}
              >
                <ArrowForwardIosIcon />
              </IconButton>
            )}

            {/* slide counter badge */}
            {safeImage.length > 1 && (
              <Box sx={{ position: "absolute", bottom: 12, left: "50%", transform: "translateX(-50%)", bgcolor: "rgba(0,0,0,0.5)", color: "#fff", borderRadius: "12px", px: 1.5, py: 0.3, fontSize: 13, pointerEvents: "none", zIndex: 3 }}>
                {activeIndex + 1} / {safeImage.length}
              </Box>
            )}
          </Box>
        </DialogContent>
      </Dialog>

    </Box>
  )
}

export default Syndicate_properties_card
